import React, { useEffect, useRef, useState } from "react";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import IconButton from "@mui/material/IconButton";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import { FileUploader } from "react-drag-drop-files";
import Button from "@mui/material/Button";
import { getCategoryList } from "../../../apis/category";
import { useQuery, useQueryClient, useMutation } from "@tanstack/react-query";
import { editProduct } from "../../../apis/product";
import Spinner from "../../../components/spinner";
import MuiAlert from "@mui/material/Alert";
import Modal from "@mui/material/Modal";
import { GrAdd } from "react-icons/gr";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import Configurations from "../../../components/section/configurations";
import ProductDetails from "../../../components/elements/ProductDetails/ProductDetails";
import useReadUpdated from "../../../hooks/updated/useRead";
import useRead from "../../../hooks/useRead";
import Loader from "../../../components/loader";
import Layout from "../../../components/layout";
import Summary from "../../../components/section/configurations/summary/Summary";
import GeneratedProducts from "./GeneratedProducts";
import useCreate from "../../../hooks/useCreate";
import useUploadMedia from "../../../hooks/file/useUploadMedia";
import toast from "react-hot-toast";
import deBounce from "../../../hooks/useDebounce";
import Editor from "../../../components/elements/Editor";
import { ReactSortable } from "react-sortablejs";
import CategorySelectModal from "./CategorySelectModal";
import CategorySelectButton from "./CategorySelectButton";
import IngredientsSelectModal from "./IngredientsSelectModal";
import IngredientsSelectButton from "./IngredientsSelectButton";
import ConcernSelectModal from "./ConcernSelectModal";
import ConcernSelectButton from "./ConcernSelectButton";
import AsyncSelect from "../../../components/elements/inputs/AsyncSelect";
import useGet from "../../../hooks/useGet";
import EditProductDetails from "../../../components/elements/ProductDetails/EditProductDetails";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import { onNumberKeydown, onNumberFieldPaste } from "../../../utilities";

const fileTypes = ["JPG", "PNG", "JPEG", "WEBP"];
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const IS_REQUIRED = true;
function EditProduct({}) {
  const initialData = {
    pageNo: 0,
    limit: 50,
    searchQuery: "",
  };
  const navigate = useNavigate();
  const { id } = useParams();
  const productImageUpload = useRef(null);
  const [brandListOptions, setBrandListOptions] = useState([]);
  const [frameListOptions, setFrameListOptions] = useState([]);
  const [genderListOptions, setGenderListOptions] = useState([]);
  const [taxListOptions, setTaxListOptions] = useState([]);
  const queryClient = useQueryClient();
  const [productData, setProductData] = useState(null);
  const [slugCheck, setSlugCheck] = useState();
  const [slug, setSlug] = useState();
  const [categoryModalOpen, setCategoryModalOpen] = useState(false);
  const [selectedCategories, setSelectedCategories] = useState([]);

  // New state for ingredients and concerns
  const [ingredientsModalOpen, setIngredientsModalOpen] = useState(false);
  const [selectedIngredients, setSelectedIngredients] = useState([]);
  const [concernModalOpen, setConcernModalOpen] = useState(false);
  const [selectedConcerns, setSelectedConcerns] = useState([]);

  const { paramsObject, data: editProductData } = useRead({
    method: "GET",
    url: "product/view",
    initialData: {
      id: id,
    },
    onSuccess: (res) => {
      let productDetail = res?.product_details;
      setProductData(productDetail);
      setImagePreview(productDetail?.thumbnail?.image_url);

      // Store the brand name from the API response
      if (productDetail?.brand) {
        setSelectedBrandName(productDetail.brand);
      }
    },
  });
  const editproductdata = editProductData?.data?.product_details;

  const [isError, setIsError] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleAddFromData = (e, file, isFileObject, name) => {
    let data;
    if (e.target.name === "product_name") {
      let newval = e.target.value;
      newval = newval.replace(/\s+/g, "-").toLowerCase();
      let sanval = sanitizetext(newval);
      let data = {
        ...productData,
        slug: sanval,
        product_name: e.target.value,
      };
      setProductData(data);
      setSlug(data);
      let senddata = {
        slug: sanval,
      };
      deBounce((e) => callapi(e, senddata), senddata);
      return;
    } else {
      if (file) {
        if (isFileObject) {
          data = {
            ...productData,
            [name]: e,
          };
        } else {
          let fileObject = e.target.files[0];
          data = {
            ...productData,
            [e.target.name]: fileObject,
          };
        }
      } else {
        if (e.target.name === "seo") {
          let value = e.target.value;
          let tempName = e.target.attributes["data-name"].value;
          data = {
            ...productData,
            seo: {
              ...productData?.seo,
              [tempName]: value,
            },
          };
        } else {
          let value = e.target.value;
          data = {
            ...productData,
            [e.target.name]: value,
          };
        }
      }
    }
    setProductData(data);
  };
  const slugInput = (e) => {
    let val = e.target.value;
    val = val.replace(/\s+/g, "-").toLowerCase();
    let sanval = sanitizetext(val);
    let data = {
      ...productData,
      slug: sanval,
    };
    // setSlug(sanval)
    setProductData(data);
    setSlug({ ...data });
    let senddata = {
      slug: sanval,
    };
    deBounce((e) => callapi(e, senddata), senddata);
  };

  const postProductDataToServer = useMutation((data) => editProduct(data), {
    onSuccess: (data) => {
      if (data.status === 200) {
        queryClient.invalidateQueries("productList");
        setIsSuccess(true);
        setTimeout(() => {
          handleCloseAndReset();
        }, 2000);
        toast.success("Product Edited Successfully", {
          position: "top-right",
          duration: 3000,
        });
      }
    },
    onError: () => {
      setIsError(true);
      toast.error("Oops! Someting Went Wrong", {
        position: "top-right",
        duration: 3000,
      });
    },
  });
  const closeErrorMessage = () => {
    setIsError(false);
  };
  const { setDataToServer } = useCreate({
    url: "product/update",
    refreshUrl: "product/list",
    onSuccess: () => {
      toast.success("Product Updated Successfully", {
        position: "top-right",
        duration: 3000,
      });
    },
    onError: (err) => {
      const apiMessage = err?.response?.data?.message;
      toast.error(apiMessage || "Error updating product", {
        position: "top-right",
        duration: 3000,
      });
    },
  });

  function sanitizetext(intext) {
    const noSpecialChars = intext.replace(/[^a-zA-Z0-9\-]/g, "");
    // urlcheck(noSpecialChars)
    return noSpecialChars;
  }
  const callapi = (e, data) => {
    checkSlugData.mutate(data);
  };

  const { setDataToServer: checkSlugData } = useCreate({
    refreshUrl: undefined,
    url: "product/check_slug",
    onSuccess: (data) => {
      setSlugCheck(false);
      // setIsSuccess(true)
    },
    onError: (err) => {
      setSlugCheck(true);
      // setIsError(true)
    },
  });
  const handleProductSubmit = (e) => {
    e.preventDefault();
    setDataToServer.mutate(productData);
  };
  const handleCloseAndReset = () => {
    closeErrorMessage();
  };
  const handleuploadAgain = () => {
    let data = {
      ...productData,
      product_thumbnail_preview: "",
      product_thumbnail: "",
    };
    setProductData(data);
  };
  // useQuery(['categoryList'], getCategoryList, {
  //     refetchOnWindowFocus: false,
  //     onSuccess: (data) => {
  //         setCategoryList(data.data)
  //     }
  // })
  useEffect(() => {
    isError && setTimeout(() => setIsError(false), [4000]);
  }, [isError]);

  const [openUploadImagesModal, setOpenUploadImagesModal] = useState(false);
  const handleOpenUploadModal = () => {
    setOpenUploadImagesModal(true);
  };
  const handleCloseUploadImageModal = () => {
    setOpenUploadImagesModal(false);
  };
  const handleClickOpenFileDialog = () => {
    productImageUpload.current.click();
  };
  const handleUploadImages = (e) => {
    let previewImag = [];
    for (let i = 0; i < e.target.files.length; i++) {
      previewImag.push(URL.createObjectURL(e.target.files[i]));
    }
    let data = {
      ...productData,
      images_of_product: [...productData?.images_of_product, ...e.target.files],
      images_of_product_preview: [
        ...productData?.images_of_product_preview,
        ...previewImag,
      ],
    };
    setProductData(data);
  };

  const handleRemoveSelectedProductImage = (e, id) => {
    e.stopPropagation();
    let predData = productData;
    predData.images_of_product_preview.splice(id, 1);
    predData.images_of_product.splice(id, 1);
    setProductData({ ...productData });
  };

  const [openConfigModal, setOpenConfigModal] = useState(false);
  const handleOpenConfigurationModal = () => {
    setOpenConfigModal(true);
  };

  // const { data: categoryList } = useRead({
  //   method:"GET",
  //   url: "category/list",
  //   initialData,
  // });

  const { data: taxList } = useRead({
    method: "GET",
    url: "tax/list",
    initialData,
  });

  // Fetch brand list
  // const { data: brandList } = useRead({
  //   method: "GET",
  //   url: "brand/list",
  //   initialData,
  // });

  // Sync selectedCategories with productData.category
  useEffect(() => {
    if (productData?.category) {
      setSelectedCategories(
        productData.category.map((cat) => ({
          id: cat.category_id,
          name: cat.category_name,
        }))
      );
    }
  }, [productData?.category]);

  // Sync selectedIngredients with productData.ingredients
  useEffect(() => {
    if (productData?.ingredients) {
      setSelectedIngredients(
        productData.ingredients.map((item) => ({
          ingredient_id: item.ingredient_id,
          name: item.ingredient_name,
        }))
      );
    }
  }, [productData?.ingredients]);

  // Sync selectedConcerns with productData.concern
  useEffect(() => {
    if (productData?.concern) {
      setSelectedConcerns(
        productData.concern.map((item) => ({
          concern_id: item.concern_id,
          name: item.concern_name,
        }))
      );
    }
  }, [productData?.concern]);

  // Handle open/close modal for categories
  const handleOpenCategoryModal = () => setCategoryModalOpen(true);
  const handleCloseCategoryModal = () => setCategoryModalOpen(false);

  // Handle open/close modal for ingredients
  const handleOpenIngredientsModal = () => setIngredientsModalOpen(true);
  const handleCloseIngredientsModal = () => setIngredientsModalOpen(false);

  // Handle open/close modal for concerns
  const handleOpenConcernModal = () => setConcernModalOpen(true);
  const handleCloseConcernModal = () => setConcernModalOpen(false);

  // Handle save from modal
  const handleSaveCategories = (categories) => {
    setSelectedCategories(categories);
    setProductData({
      ...productData,
      category: categories.map((cat) => ({
        category_id: cat.id,
        category_name: cat.name,
      })),
    });
    setCategoryModalOpen(false);
  };

  // Handle save ingredients from modal
  const handleSaveIngredients = (ingredients) => {
    setSelectedIngredients(ingredients);
    setProductData({
      ...productData,
      ingredients: ingredients.map((item) => ({
        ingredient_id: item.ingredient_id,
        ingredient_name: item.name,
      })),
    });
    setIngredientsModalOpen(false);
  };

  // Handle save concerns from modal
  const handleSaveConcerns = (concerns) => {
    setSelectedConcerns(concerns);
    setProductData({
      ...productData,
      concern: concerns.map((item) => ({
        concern_id: item.concern_id,
        concern_name: item.name,
      })),
    });
    setConcernModalOpen(false);
  };

  let uploadScreen;
  const { upload: uploadmultiimage } = useUploadMedia({
    url: "upload/image",
    refreshUrl: "",
    onSuccess: (res) => {
      let productCopy = { ...productData };
      if (uploadScreen === "thumbnail") {
        productCopy["thumbnail"] = { image_alt: "", ...res.data[0] };
      } else {
        let copyPrductAdditionalImage = productCopy["additional_product_image"];
        copyPrductAdditionalImage = [
          ...productCopy["additional_product_image"],
          ...res.data.map((addImg) => {
            return { image_alt: "", ...addImg };
          }),
        ];
        productCopy["additional_product_image"] = copyPrductAdditionalImage;
      }
      setProductData(productCopy);
    },
    onError: (err) => {
      const apiMessage = err?.response?.data?.message;
      toast.error(apiMessage || "Error Uploading Image", {
        position: "top-right",
        duration: 3000,
      });
    },
  });

  const { upload: ImagesUpload } = useUploadMedia({
    url: "upload/image",
    refreshUrl: "",
    onSuccess: (res) => {
      let copyProduct = { ...productData };
      if (uploadScreen === "product_thumbnail") {
        copyProduct["product_thumbnail"] = { image_alt: "", ...res.data[0] };
      } else {
        let copyAdditionalProductImage =
          copyProduct["additional_product_image"];
        copyAdditionalProductImage = [...copyAdditionalProductImage, res?.data];
        copyProduct["additional_product_image"] = copyAdditionalProductImage;
      }
      setProductData(copyProduct);
      toast.success("Image Uploaded Successfully", {
        position: "top-right",
        duration: 3000,
      });
    },
    onError: (err) => {
      const apiMessage = err?.response?.data?.message;
      toast.error(apiMessage || "Error Uploading Image", {
        position: "top-right",
        duration: 3000,
      });
    },
  });
  const handleUploadFile = (e) => {
    let thumbnail = e.target?.files[0];

    let data = {
      screen: "products",
      thumbnail: [thumbnail],
    };
    upload.mutate(data);
  };
  const handleImagesUploadFile = (e, screen) => {
    // let thumbnail = files[0];
    uploadScreen = screen;
    const data = {
      screen: "products",
      thumbnail: [...e],
    };
    // setUploadScreen(uploadScreen); // Set the context for onSuccess callback

    ImagesUpload.mutate(data);
  };
  const handleChangeThumbImageAlt = (e) => {
    let productCopy = { ...productData };
    if (productCopy["thumbnail"]) {
      productCopy["thumbnail"][e.target.name] = e.target.value;
      setProductData(productCopy);
    }
  };

  const handleRemoveProductImage = (id) => {
    let productCopy = { ...productData };
    productCopy.additional_product_image =
      productCopy.additional_product_image.filter((x) => x.image_id !== id);
    setProductData(productCopy);
  };

  const handleChangeEditor = (e, value) => {
    let data = {
      ...productData,
      description: value,
    };
    setProductData(data);
  };

  const setProductDetailsList = (val) => {
    let newData = { ...productData };
    newData.additional_product_image = val;
    setProductData(newData);
  };

  const handleCheckBox = (e) => {
    let data = {
      ...productData,
      [e.target.name]: e.target.checked,
    };
    setProductData(data);
  };
  const fileInputRef = useRef(null);
  const [imagePreview, setImagePreview] = useState(null);
  const handleOpenFileUploadDialog = () => {
    fileInputRef.current.click();
  };
  const { upload } = useUploadMedia({
    url: "upload/image",
    onSuccess: (res) => {
      const { image_url, image_id } = res?.data;
      let formDataCopy = productData;
      //   formDataCopy.thumbnail = {};
      formDataCopy["thumbnail"].image_id = image_id;

      setImagePreview(image_url);
      setProductData({ ...productData });
    },
    onError: (err) => {
      const apiMessage = err?.response?.data?.message;
      toast.error(apiMessage || "Error Uploading Image", {
        position: "top-right",
        duration: 3000,
      });
    },
  });
  // Add these state variables for AsyncSelect
  const [brandOptions, setBrandOptions] = useState([]);
  const [brandHasMore, setBrandHasMore] = useState(true);
  const [brandPageNo, setBrandPageNo] = useState(0);
  const [brandSearchQuery, setBrandSearchQuery] = useState("");
  const [selectedBrandName, setSelectedBrandName] = useState("");

  // Add useGet implementation for brand data
  const {
    data: brandData,
    setParamsObject: setBrandParams,
    data: brandQuery,
  } = useGet({
    url: "brand/list",
    initialParams: {
      pageNo: 0,
      limit: 10,
      searchQuery: "",
    },
    onSuccess: (response) => {
      const formattedOptions =
        response?.data?.map((brand) => ({
          value: brand.brand_id,
          label: brand.name,
        })) || [];

      if (brandPageNo === 0) {
        setBrandOptions(formattedOptions);
      } else {
        setBrandOptions((prev) => [...prev, ...formattedOptions]);
      }

      setBrandHasMore(
        formattedOptions.length > 0 &&
          response?.totalCount > brandOptions.length
      );
    },
    onError: (err) => {
      console.error("Brand fetch error:", err);
    },
  });

  // Add fetchBrands function for AsyncSelect
  const fetchBrands = (query = "", reset = false) => {
    const pageToFetch = reset ? 0 : brandPageNo;

    if (reset) {
      setBrandPageNo(0);
      setBrandOptions([]);
    }

    setBrandParams({
      pageNo: pageToFetch,
      limit: 10,
      searchQuery: query,
    });

    if (!reset) {
      setBrandPageNo((prev) => prev + 1);
    }

    setBrandSearchQuery(query);
  };

  // Add brand selection handler
  const handleBrandSelect = (brandId) => {
    let data = {
      ...productData,
      brand_id: brandId,
    };
    setProductData(data);
  };

  return (
    <>
      <div className="container_xxl relative z-10 px-4">
        <div className="flex items-center space-x-4 headingBorder__b">
          <div>
            <IconButton onClick={() => navigate(-1)}>
              <ArrowBackIcon />
            </IconButton>
          </div>
          <div>
            <h1 className="heading">Edit Product</h1>
          </div>
        </div>
        {editProductData.isLoading ? (
          <Loader />
        ) : (
          <div className="form-body py-8">
            <form
              className=""
              autoComplete="off"
              onSubmit={handleProductSubmit}
            >
              <div className="grid grid-cols-1 gap-4">
                <div className="mb-3 flex items-center justify-between border-b border-gray-400">
                  <h1 className="font-semibold text-2xl pb-3">
                    Product Listing
                  </h1>
                </div>
                <div>
                  <label htmlFor="Product Name" className="label">
                    Product Name <small className="text-red-700">*</small>
                  </label>
                  <input
                    required
                    type="text"
                    placeholder="Product Name"
                    name="product_name"
                    className="input"
                    value={productData?.product_name}
                    onChange={handleAddFromData}
                  />
                </div>
                <div>
                  <label htmlFor="Slug" className="label">
                    Slug <small className="text-red-700">*</small>
                  </label>
                  <input
                    required
                    type="text"
                    placeholder="Slug"
                    name="slug"
                    className="input"
                    value={productData?.slug}
                    onChange={slugInput}
                  />
                  {slugCheck ? (
                    <p
                      className="slugerror text-red-600 text-base mb-6 mt-6 font-semibold"
                      id="slugerror"
                    >
                      Slug already exist
                    </p>
                  ) : (
                    " "
                  )}
                </div>
                <div className="flex flex-col md:flex-row w-full justify-center items-center gap-5">
                  {/* <div className="w-full">
                    <label htmlFor="Product Short Name" className="label">
                      Product Short Name{" "}
                      <small className="text-red-700">*</small>
                    </label>
                    <input
                      type="text"
                      placeholder="Product Short Name"
                      name="short_name"
                      className="input"
                      value={productData?.short_name}
                      onChange={handleAddFromData}
                    />
                  </div> */}
                  <div className="w-full">
                    <label className="label">
                      Brand <small className="text-red-700">*</small>
                    </label>
                    <AsyncSelect
                      // label="Select Brand"
                      options={brandOptions}
                      hasMore={brandHasMore}
                      fetchNext={fetchBrands}
                      isLoading={brandQuery?.isFetching}
                      value={productData?.brand_id}
                      onChange={handleBrandSelect}
                      defaultLabel={
                        selectedBrandName ||
                        brandOptions.find(
                          (opt) => opt.value === productData?.brand_id
                        )?.label ||
                        ""
                      }
                    />
                  </div>
                </div>
                <div className="flex items-center gap-8 mt-2 mb-2">
                  <label className="flex items-center cursor-pointer gap-2">
                    {productData?.best_selling ? (
                      <CheckBoxIcon color="primary" />
                    ) : (
                      <CheckBoxOutlineBlankIcon color="action" />
                    )}
                    <input
                      type="checkbox"
                      name="best_selling"
                      checked={!!productData?.best_selling}
                      onChange={handleCheckBox}
                      className="hidden"
                    />
                    <span>Best Selling</span>
                  </label>
                  <label className="flex items-center cursor-pointer gap-2">
                    {productData?.new_arrivals ? (
                      <CheckBoxIcon color="primary" />
                    ) : (
                      <CheckBoxOutlineBlankIcon color="action" />
                    )}
                    <input
                      type="checkbox"
                      name="new_arrivals"
                      checked={!!productData?.new_arrivals}
                      onChange={handleCheckBox}
                      className="hidden"
                    />
                    <span>New Arrival</span>
                  </label>
                </div>
              </div>
              <div className="grid grid-cols-1 gap-4">
                <div className="mb-3 mt-10 flex items-center justify-between border-b border-gray-400">
                  <h1 className="font-semibold text-2xl pb-3">Product Info</h1>
                </div>
                <div>
                  <label htmlFor="Product Title" className="label">
                    Title <small className="text-red-700">*</small>
                  </label>
                  <input
                    type="text"
                    placeholder="Product Name"
                    name="title"
                    className="input"
                    value={productData?.title || ""}
                    onChange={handleAddFromData}
                  />
                </div>
                {/* <div>
                  <label htmlFor="Product Subtitle" className="label">
                    Subtitle <small className="text-red-700">*</small>
                  </label>
                  <input
                    type="text"
                    placeholder="Product Name"
                    name="subtitle"
                    className="input"
                    value={productData?.subtitle || ""}
                    onChange={handleAddFromData}
                  />
                </div> */}
                <section className="grid grid-cols-1 md:grid-cols-2 gap-4 ">
                  {/* --- Item Code field --- */}
                  <div>
                    <label htmlFor="Item Code" className="label">
                      Item Code
                    </label>
                    <input
                      type="text"
                      placeholder="Item Code"
                      name="item_code"
                      className="input"
                      value={productData?.item_code || ""}
                      onChange={handleAddFromData}
                    />
                  </div>
                  {/* --- HSN Code field --- */}
                  <div>
                    <label htmlFor="HSN Code" className="label">
                      HSN Code
                    </label>
                    <input
                      type="text"
                      placeholder="HSN Code"
                      name="hsn_code"
                      className="input"
                      value={productData?.hsn_code || ""}
                      onChange={handleAddFromData}
                    />
                  </div>
                  {/* --- Article No. field --- */}
                  <div>
                    <label htmlFor="Article No." className="label">
                      Article No.
                    </label>
                    <input
                      type="text"
                      placeholder="Article No."
                      name="article_no"
                      className="input"
                      value={productData?.article_no || ""}
                      onChange={handleAddFromData}
                    />
                  </div>
                  <div>
                    <label htmlFor="Parent Article No." className="label">
                      Parent Article No.
                    </label>
                    <input
                      type="text"
                      placeholder="Parent Article No."
                      name="parent_article_no"
                      disabled
                      className="input"
                      value={productData?.parent_article_no || ""}
                      onChange={handleAddFromData}
                    />
                  </div>
                  {/* --- SKU field --- */}
                  <div>
                    <label htmlFor="SKU" className="label">
                      SKU
                    </label>
                    <input
                      type="text"
                      placeholder="SKU"
                      name="sku_code"
                      className="input"
                      value={productData?.sku_code || ""}
                      onChange={handleAddFromData}
                    />
                  </div>
                </section>
                {/* --- EN field --- */}
                {/* <div>
                  <label htmlFor="EN" className="label">
                    EN
                  </label>
                  <input
                    type="text"
                    placeholder="EN"
                    name="en"
                    className="input"
                    value={productData?.en || ""}
                    onChange={handleAddFromData}
                  />
                </div> */}
                <div>
                  <label htmlFor="Description" className="label">
                    Description <small className="text-red-700">*</small>
                  </label>
                  <Editor
                    value={productData?.description || ""}
                    onChange={handleChangeEditor}
                  />
                  {/* <textarea name="description" className=' min-h-[10rem] input' value={productData?.description} onChange={handleAddFromData}></textarea> */}
                </div>
                {/* <div>
                  <label htmlFor="Product Short description" className="label">
                    {" "}
                    Short Description <small className="text-red-700">*</small>
                  </label>
                  <textarea
                    name="short_description"
                    className=" min-h-[10rem] input"
                    value={productData?.short_description || ""}
                    onChange={handleAddFromData}
                  ></textarea>
                </div> */}
              </div>
              <div>
                <div className="my-7 flex items-center justify-between border-b border-gray-400">
                  <h1 className="font-semibold text-2xl pb-3">
                    Product Details
                  </h1>
                </div>
                <div className=" space-y-7">
                  <div className={`grid grid-cols-1 md:grid-cols-3 gap-4`}>
                    {/* <div>
                      <label className="label">
                        Price <small className="text-red-700">*</small>
                      </label>
                      <input
                        required
                        type="text"
                        placeholder="Price"
                        name="mrp_price"
                        className="input"
                        value={editproductdata?.mrp_price}
                        onChange={handleAddFromData}
                      />
                    </div> */}
                    {/* <div>
                      <label className="label">
                        Quantity <small className="text-red-700">*</small>
                      </label>
                      <input
                        required
                        type="text"
                        placeholder="quantity"
                        name="quantity"
                        className="input"
                        value={editproductdata?.quantity}
                        onChange={handleAddFromData}
                      />
                    </div> */}
                    {/* <div>
                      <label className="label">
                        SKU <small className="text-red-700">*</small>
                      </label>
                      <input
                        required
                        type="text"
                        placeholder="SKU"
                        name="sku"
                        className="input"
                        value={editproductdata?.sku}
                        onChange={handleAddFromData}
                      />
                    </div> */}

                    <div>
                      <label className="label">
                        MRP Price <small className="text-red-700">*</small>
                      </label>
                      <input
                        required
                        type="number"
                        placeholder="MRP Price"
                        name="mrp_price"
                        className="input"
                        value={productData?.mrp_price || ""}
                        onChange={handleAddFromData}
                      />
                    </div>
                    <div>
                      <label className="label">
                        Selling Price <small className="text-red-700">*</small>
                      </label>
                      <input
                        required
                        type="number"
                        placeholder="Selling Price"
                        name="selling_price"
                        className="input"
                        value={productData?.selling_price || ""}
                        onChange={handleAddFromData}
                      />
                    </div>
                    <div>
                      <label className="label">
                        Business Selling Price{" "}
                        <small className="text-red-700">*</small>
                      </label>
                      <input
                        required
                        type="number"
                        placeholder="Business Selling Price"
                        name="business_selling_price"
                        className="input"
                        value={productData?.business_selling_price || ""}
                        onChange={handleAddFromData}
                      />
                    </div>
                    <div>
                      <label className="label">
                        Category <small className="text-red-700">*</small>
                      </label>
                      <CategorySelectButton
                        count={selectedCategories.length}
                        onClick={handleOpenCategoryModal}
                      />
                      <CategorySelectModal
                        open={categoryModalOpen}
                        onClose={handleCloseCategoryModal}
                        selected={selectedCategories}
                        onSave={handleSaveCategories}
                      />
                    </div>
                    <div>
                      <label className="label">Ingredients</label>
                      <IngredientsSelectButton
                        count={selectedIngredients.length}
                        onClick={handleOpenIngredientsModal}
                      />
                      <IngredientsSelectModal
                        open={ingredientsModalOpen}
                        onClose={handleCloseIngredientsModal}
                        selected={selectedIngredients}
                        onSave={handleSaveIngredients}
                      />
                    </div>
                    <div>
                      <label className="label">Concerns</label>
                      <ConcernSelectButton
                        count={selectedConcerns.length}
                        onClick={handleOpenConcernModal}
                      />
                      <ConcernSelectModal
                        open={concernModalOpen}
                        onClose={handleCloseConcernModal}
                        selected={selectedConcerns}
                        onSave={handleSaveConcerns}
                      />
                    </div>
                    <div>
                      <label className="label">Unit Price Value</label>
                      <input
                        type="number"
                        placeholder="Unit Price Value"
                        name="up_value"
                        className="input"
                        value={productData?.up_value || ""}
                        onChange={handleAddFromData}
                        onKeyDown={(e) =>
                          onNumberKeydown(e, { isPositiveNumber: true })
                        }
                        onPaste={(e) =>
                          onNumberFieldPaste(e, { isPositiveNumber: true })
                        }
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                    <div>
                      <label className="label">Unit Price Total</label>
                      <input
                        type="number"
                        placeholder="Unit Price Total"
                        name="up_total"
                        className="input"
                        value={productData?.up_total || ""}
                        onChange={handleAddFromData}
                        onKeyDown={(e) =>
                          onNumberKeydown(e, { isPositiveNumber: true })
                        }
                        onPaste={(e) =>
                          onNumberFieldPaste(e, { isPositiveNumber: true })
                        }
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                    <div>
                      <label className="label">Unit</label>
                      <input
                        type="text"
                        placeholder="Unit (e.g., ml, gm, oz)"
                        name="up_unit"
                        className="input"
                        value={productData?.up_unit || ""}
                        onChange={handleAddFromData}
                      />
                    </div>
                    <div>
                      <label className="label">
                        Gender
                        {/* <small className="text-red-700">*</small> */}
                      </label>
                      <select
                        name="gender"
                        value={productData?.gender || ""}
                        className="input"
                        onChange={handleAddFromData}
                      >
                        <option value="">--Select Gender--</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                        <option value="Unisex">Unisex</option>
                      </select>
                    </div>
                    {/* <div>
                      <label className="label">
                        Product Unit <small className="text-red-700">*</small>
                      </label>
                      <select
                        name="content_type"
                        value={editproductdata?.content_type}
                        id=""
                        className="input"
                        onChange={handleAddFromData}
                      >
                        <option value="">--Select Unit--</option>
                        <option value="grams">Grams</option>
                        <option value="liters">Liters</option>
                      </select>
                    </div> */}
                    {/* <div>
                      <label className="label">
                        Product Weight<small className="text-red-700">*</small>
                      </label>
                      <input
                        type="number"
                        placeholder="weight"
                        name="weight"
                        className="input"
                        value={editproductdata?.weight}
                        onChange={handleAddFromData}
                      />
                    </div> */}
                    {/* <div>
                      <div className="flex items-center space-x-2">
                        <input
                          type="checkbox"
                          placeholder="charge_incl"
                          id="charge_incl"
                          name="charge_incl"
                          value={editproductdata?.charge_incl}
                          onChange={handleCheckBox}
                        />
                        <label
                          htmlFor="charge_incl"
                          className="cursor-pointer select-none"
                        >
                          Product Delivery Charges Inclusive{" "}
                          <small className="text-red-700">*</small>
                        </label>
                      </div>
                    </div> */}
                    <div>
                      <label className="label">
                        Tax <small className="text-red-700">*</small>
                      </label>
                      <select
                        name="tax_id"
                        value={productData?.tax_id || ""}
                        className="input"
                        onChange={handleAddFromData}
                      >
                        <option value="">--Select Tax--</option>
                        {taxList?.data?.data?.map((tax) => (
                          <option key={tax.id} value={tax.id}>
                            {tax.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <div className="my-7 flex items-center justify-between border-b border-gray-400">
                  <h1 className="font-semibold text-2xl pb-3">
                    Search Engine Optimization
                  </h1>
                </div>
                <div>
                  <div className="mb-2">
                    <label className="label">Meta Title</label>
                    <input
                      type="text"
                      placeholder="Meta Title"
                      name="meta_title"
                      // data-name="meta_title"
                      className="input"
                      value={productData?.["meta_title"] || ""}
                      onChange={handleAddFromData}
                    />
                  </div>
                  {/* <div className="mb-2">
                    <label className="label">Meta Keywords</label>
                    <input
                      type="text"
                      placeholder="Meta Keywords"
                      name="seo"
                      data-name="meta_keywords"
                      className="input"
                      value={productData?.seo?.["meta_keywords"] || ""}
                      onChange={handleAddFromData}
                    />
                  </div> */}
                  <div className="mb-2">
                    <label className="label">Meta Description</label>
                    <input
                      type="text"
                      placeholder="Meta Description"
                      name="meta_description"
                      className="input"
                      value={productData?.["meta_description"] || ""}
                      onChange={handleAddFromData}
                    />
                  </div>
                </div>
              </div>

              {/* <ProductDetails
                                    productData={productData}
                                    setProductData={setProductData}
                                /> */}
              <EditProductDetails
                productData={productData}
                setProductData={setProductData}
              />
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <div className="my-7 flex items-center justify-between border-b border-gray-400">
                    <div className="pb-3">
                      <h1 className="font-semibold text-2xl">
                        Thumbnail of product
                      </h1>
                      <small className="text-red-700">
                        Note:Image to be less than 1mb
                      </small>
                    </div>
                  </div>
                  <div className="">
                    <label htmlFor="" className="label">
                      Thumbnail <small className="text-red-700">*</small>
                    </label>
                    {upload.isLoading ? (
                      <>
                        <Spinner />
                      </>
                    ) : (
                      <>
                        {imagePreview && (
                          <img
                            src={imagePreview}
                            alt="blog image"
                            className="object-contain w-48 h-48 my-4"
                          />
                        )}
                      </>
                    )}

                    <div className="mt-5">
                      <Button
                        variant="contained"
                        color="success"
                        className="primaryBtn-contained"
                        onClick={handleOpenFileUploadDialog}
                      >
                        {imagePreview
                          ? "Update Thumbnail Image "
                          : " Add Thumbnail Image"}
                      </Button>
                      <input
                        ref={fileInputRef}
                        type="file"
                        className="hidden"
                        onChange={(e) => handleUploadFile(e)}
                      />
                    </div>
                    {/* Add image_alt input for thumbnail */}
                    <div className="mt-4">
                      <label htmlFor="image_alt" className="label">
                        Image alt
                      </label>
                      <input
                        type="text"
                        placeholder="Enter image alt"
                        value={productData?.thumbnail?.image_alt || ""}
                        onChange={handleChangeThumbImageAlt}
                        name="image_alt"
                        className="input"
                      />
                    </div>
                  </div>
                </div>
                <div>
                  <div className="my-7 flex items-center justify-between border-b border-gray-400">
                    <div className="pb-3">
                      <h1 className="font-semibold text-2xl">
                        Images of product
                      </h1>
                      <small className="text-red-700">
                        Note:Image to be less than 1mb
                      </small>
                    </div>
                  </div>
                  <div className="flex items-center justify-center mt-12">
                    <Button
                      onClick={handleOpenUploadModal}
                      variant="contained"
                      color="success"
                      className="primaryBtn-contained"
                    >
                      Add Images
                    </Button>
                  </div>
                </div>
              </div>
              <div className="text-center my-6">
                {postProductDataToServer.isLoading ? (
                  <Spinner />
                ) : (
                  <Button
                    type="submit"
                    variant="contained"
                    className="primaryBtn-contained"
                  >
                    Save Product
                  </Button>
                )}
              </div>
            </form>
          </div>
        )}
      </div>
      <Modal
        open={openUploadImagesModal}
        onClose={handleCloseUploadImageModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className=" w-full absolute top-4 left-1/2 -translate-x-1/2">
          <div className=" max-w-5xl mx-auto bg-white">
            <div className=" divide-y">
              <div className="head-modal">
                <div className="flex items-center space-x-4 px-6">
                  <div
                    className="w-7 h-7 cursor-pointer"
                    onClick={handleCloseUploadImageModal}
                  >
                    <svg
                      className="w-full h-full"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="2"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
                      />
                    </svg>
                  </div>
                  <h2 className="heading text-3xl">Upload Product Images</h2>
                </div>
              </div>
              <div className="body-modal py-4 px-6">
                <div className="max-h-[20rem] min-h-[20rem] overflow-auto  relative cursor-pointer">
                  <div className="imagePreview__container relative z-10">
                    {/* <div className="grid grid-cols-4 gap-4 "> */}
                    <ReactSortable
                      className="grid grid-cols-4 gap-4"
                      list={productData?.additional_product_image}
                      setList={setProductDetailsList}
                    >
                      {productData?.additional_product_image?.map(
                        (img, idx) => {
                          return (
                            <div key={idx}>
                              <div
                                className=" w-full overflow-hidden border p-2 relative cursor-default"
                                key={idx}
                              >
                                <div className="w-6 h-6 cursor-pointer float-right">
                                  <svg
                                    onClick={() =>
                                      handleRemoveProductImage(img.image_id)
                                    }
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth="1.5"
                                    stroke="currentColor"
                                    className="w-full h-full"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                    />
                                  </svg>
                                </div>
                                <img
                                  src={img.image_url}
                                  alt="img"
                                  className="w-full h-40 object-contain"
                                />
                                <div className="my-2">
                                  <label className="label">
                                    Product {idx + 1} Alt Tag
                                  </label>
                                  <input
                                    type="text"
                                    value={img.image_alt}
                                    placeholder={`Product ${idx + 1} Alt Tag`}
                                    name="image_alt"
                                    className="input"
                                  />
                                </div>
                              </div>
                            </div>
                          );
                        }
                      )}
                      <div
                        onClick={handleClickOpenFileDialog}
                        className="w-full h-48 cursor-pointer select-none border-2 rounded-md border-dashed border-gray-400 flex flex-col items-center justify-center hover:shadow-lg"
                      >
                        <GrAdd className=" w-16 h-16 text-gray-400" />
                        <small>Add Product Image</small>
                      </div>
                    </ReactSortable>
                    {/* </div> */}
                  </div>
                  <input
                    type="file"
                    className="hidden"
                    ref={productImageUpload}
                    onChange={(e) =>
                      handleImagesUploadFile(
                        e.target.files,
                        "additional_product_image"
                      )
                    }
                    multiple
                    accept="image/jpeg, image/png, image/jpg, image/webp"
                  />
                </div>
              </div>
              <div className="foot-modal py-4 text-center">
                <Button
                  variant="contained"
                  className="primaryBtn-contained px-10"
                  onClick={handleCloseUploadImageModal}
                >
                  Save Images
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default EditProduct;
